import { Box, Text } from '@mantine/core'
import { type ReactQuery } from 'cms-api'
import React from 'react'
import Icon from 'components/Icon/Icon'

type Tier = ReactQuery.ExpertDashboardTradeTierResponse['currentTier']

export const TIER_COLORS: Record<Tier, string> = {
  Member: '#126554',
  Bronze: '#B25100',
  Silver: '#949494',
  Gold: '#E7A748',
  Platinum: '#949494',
}

const TIER_STYLES: Record<
  Tier,
  {
    color: string
    background: string
    border: string
  }
> = {
  Member: {
    color: TIER_COLORS.Member,
    background: '#DDEAE7',
    border: TIER_COLORS.Member,
  },
  Bronze: {
    color: TIER_COLORS.Bronze,
    background: '#FFF3EA',
    border: TIER_COLORS.Bronze,
  },
  Silver: {
    color: TIER_COLORS.Silver,
    background: '#F0F0F0',
    border: TIER_COLORS.Silver,
  },
  Gold: {
    color: TIER_COLORS.Gold,
    background: '#FBF0E3',
    border: TIER_COLORS.Gold,
  },
  Platinum: {
    color: TIER_COLORS.Platinum,
    background: '#FFFFFF',
    border: TIER_COLORS.Platinum,
  },
}

export const TradeTierBadge = ({
  tier,
  year,
}: {
  tier: Tier
  year?: number
}) => {
  const styles = TIER_STYLES[tier]

  return (
    <Box
      display="inline-flex"
      px={6}
      py={4}
      style={{
        gap: 2,
        borderRadius: 6,
        backgroundColor: styles.background,
        border: `1px solid ${styles.border}`,
        alignItems: 'center',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          color: styles.color,
        }}
      >
        <Icon.Badge color={styles.color} size={13} />
      </Box>

      <Text size="xs" fw={500} style={{ color: styles.color, lineHeight: 1 }}>
        {tier} Tier{year ? ` · ${year}` : ''}
      </Text>
    </Box>
  )
}
